<template>
    <aside :class="['main-sidebar', 'col-12', 'col-md-3', 'col-lg-2', 'px-0', sidebarVisible ? 'open' : '']">
        <div class="main-navbar">
            <nav class="navbar align-items-stretch navbar-light bg-white flex-md-nowrap border-bottom p-0">
                <a class="navbar-brand w-100 mr-0" href="#" style="line-height: 25px;">
                    <div class="d-table m-auto">
                        <img id="main-logo" class="d-inline-block align-top mr-1" style="max-width: 100px;"
                             src="../../../assets/images/logo_new_altium_png.png" alt="Wiagro Dashboard">                            
                    </div>
                </a>
                <div class="toggle-sidebar  d-sm-inline d-md-none d-lg-none " @click="handleToggleSidebar()">
                    <i class="material-icons">&#xE5C4;</i>
                </div>
            </nav>
        </div>

        <div class="nav-wrapper">
            <d-nav class="flex-column">
                <li v-for="(item, navItemIdx) in items" :key="navItemIdx" class="nav-item dropdown">
                    <span v-if="item.isInsurance">
                        <d-link v-if="showInsurance()" :class="['nav-link', item.items && item.items.length ? 'dropdown-toggle' : '']"
                            :to="item.to"
                            v-d-toggle="`snc-${navItemIdx}`"
                            @click="sidebarVisible = false">                            
                                <div class="item-icon-wrapper" v-if="item.htmlBefore" v-html="item.htmlBefore"/>
                                <span v-if="item.title">{{ $t(item.title) }}</span>
                                <div class="item-icon-wrapper" v-if="item.htmlAfter" v-html="item.htmlAfter"/>
                        </d-link>
                    </span>
                    <span v-else>
                        <d-link :class="['nav-link', item.items && item.items.length ? 'dropdown-toggle' : '']"
                            :to="item.to"
                            v-d-toggle="`snc-${navItemIdx}`"
                            @click="sidebarVisible = false">

                                <div class="item-icon-wrapper" v-if="item.htmlBefore" v-html="item.htmlBefore"/>
                                <span v-if="item.title">{{ $t(item.title) }}</span>
                                <div class="item-icon-wrapper" v-if="item.htmlAfter" v-html="item.htmlAfter"/>
                        </d-link>
                        <d-collapse v-if="item.items && item.items.length"
                                :id="`snc-${navItemIdx}`"
                                class="dropdown-menu dropdown-menu-small"
                                accordion="sidebar-items-accordion">
                            <div @click="sidebarVisible = false">
                                <d-dropdown-item v-for="(subItem, subItemIdx) in item.items"
                                             :key="subItemIdx"
                                             :href="subItem.href"
                                             :to="subItem.to"

                                >
                                {{ $t(subItem.title) }}
                                </d-dropdown-item>
                            </div>
                        </d-collapse>
                    </span>
                </li>
            </d-nav>
        </div>
        <div class="position-absolute fixed-bottom " style="padding-left: 10px" >
            <div class="font-weight-bold" style="font-size: 1em;">Smart SiloBag &#169;</div> 
            <div class="text-muted" style="font-size: 0.85em;">v{{version}}</div>
        </div>
        <!--<div class="position-absolute fixed-bottom" style="padding-left: 10px"  > 
            <div class="text-muted" style="font-size: 0.85em; " ><b>SmartSiloBag</b> v{{version}}</div>
        </div>
        -->
            
            

    </aside>
</template>

<script>
    import pjson from '../../../../package.json';


    export default {
        name: 'main-sidebar',
        props: {
            /**
             * Whether to hide the logo text, or not.
             */
            hideLogoText: {
                type: Boolean,
                default: false,
            },
            /**
             * The menu items.
             */
            items: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                sidebarVisible: false,
                version: pjson.version
            };
        },
        created() {
            this.$eventHub.$on('toggle-sidebar', this.handleToggleSidebar);
        },
        beforeDestroy() {
            this.$eventHub.$off('toggle-sidebar');
        },
        methods: {
            close() {
                this.sidebarVisible = false
            },
            handleToggleSidebar() {
                this.sidebarVisible = !this.sidebarVisible;
            },
            showInsurance() {
                return this.$store.state.user.seguro === "si";
            }
        },
    };
</script>

<style lang="scss">
    .main-sidebar {
        .item-icon-wrapper {
            display: inline-block;
        }

        .dropdown-menu {
            display: block;
        }

        .navbar-brand {
            cursor: default;
        }
    }
</style>
